import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * Les pièces qu'une contre-visite **reprend** du contrôle qu'elle suit (#675) : les quatre prises
 * de vue de l'agent, la photo d'un schéma papier comprise (#397).
 *
 * Restent au contrôle d'origine : la **signature** (elle appartient au passage d'origine), l'image
 * **rendue** du schéma (`schematic` — le dessin, lui, est recopié dans le relevé, et la tablette en
 * rend une neuve), et les **vidéos**, trop lourdes pour être dupliquées : elles se consultent
 * depuis le contrôle d'origine.
 */
export const CARRIED_MEDIUM_TYPES = ['view', 'manhole', 'stormwater', 'schematic_photo'];
/**
 * Une pièce de la visite précédente, **déjà dupliquée** pour la contre-visite (#675).
 *
 * `id` est celui de **la copie** : le serveur a recopié les octets dans le stockage, sous la clé de
 * l'équipe de la contre-visite, avant de servir la ligne. La tablette la range comme une pièce à
 * elle, déjà envoyée — aucune référence n'est partagée entre deux contrôles. `carriedFrom` garde
 * l'identifiant de la pièce d'origine : une provenance, jamais une clé.
 */
export const carriedMediumSchema = z.object({
    id: uuidV7Schema,
    carriedFrom: uuidV7Schema,
    type: z.enum(CARRIED_MEDIUM_TYPES),
    label: z.string().nullable(),
    takenAt: z.iso.datetime({ offset: true }).nullable(),
    contentType: z.string().nullable(),
});
/**
 * La liste servie avec la tournée, relue **pièce par pièce** : une ligne qu'une tablette ne sait
 * pas lire — un type ajouté côté serveur — s'écarte, elle ne fait pas tomber la tournée (M21).
 * Absente d'une ligne mise en cache avant #675 : aucune pièce.
 */
export const carriedMediaSchema = z
    .array(z.unknown())
    .default([])
    .transform((media) => media.flatMap((medium) => {
    const parsed = carriedMediumSchema.safeParse(medium);
    return parsed.success ? [parsed.data] : [];
}));
//# sourceMappingURL=carried-medium.js.map